import * as yup from 'yup';
import { InferType, ValidationError } from 'yup';
import { strings } from 'strings';
import { isEqual } from 'date-fns';

import { gameEventLevelFormSchema } from '../../GameEventLevelForm/validations/GameEventLevelFormSchema';

export const gameEventFormSchema = yup.object({
  id: yup.string().optional(),

  name: yup.string().required(strings.gameEvent.form.errors.name.required),
  difficulty: yup
    .object({
      label: yup.string(),
      value: yup.number().required(strings.gameEvent.form.errors.difficulty.required),
    })
    .typeError(strings.gameEvent.form.errors.difficulty.type)
    .required(strings.gameEvent.form.errors.difficulty.required),

  entryFee: yup
    .number()
    .typeError(strings.gameEvent.form.errors.entryFee.type)
    .min(0, strings.gameEvent.form.errors.entryFee.min)
    .required(strings.gameEvent.form.errors.entryFee.required),

  image: yup.string().required(strings.gameEvent.form.errors.image.required),

  startDate: yup.date().required(strings.gameEvent.form.errors.startDate.required),

  endDate: yup
    .date()
    .required(strings.gameEvent.form.errors.endDate.required)
    .test('end-date-greater-then-start-date', (value, context) => {
      if (isEqual(value, context.from?.[0].value.startDate)) {
        throw new ValidationError(
          strings.gameEvent.form.errors.endDate.equalStartDate,
          value,
          `endDate`,
          'string',
        );
      }

      return true;
    }),

  levels: yup
    .array()
    .of(gameEventLevelFormSchema)
    .min(1, strings.gameEvent.form.errors.levels.min)
    .required(strings.gameEvent.form.errors.levels.required),
});

export type GameEventField = InferType<typeof gameEventFormSchema>;
